import Image from 'next/legacy/image';
import styled from 'styled-components';
import { useState } from 'react';
import { theme } from '@yoweb/ui/styles';
import { Interactive, Title } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { getFontSize } from '@yoweb/ui/styles/utils/theme';
import { Button } from '@yoweb/ui/components/buttons';
import imageFallback from '@poplar/public/images/illustrations/two-people-high-five.svg';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { TodoEntryPoint, TodoType } from '@yoweb/types/external-events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TodoCard = function TodoCard(_ref) {
  var _ref$sampleTodo = _ref.sampleTodo,
      templateId = _ref$sampleTodo.templateId,
      skipPdp = _ref$sampleTodo.skipPdp,
      tileImageUrl = _ref$sampleTodo.tileImageUrl,
      title = _ref$sampleTodo.title,
      onSelect = _ref.onSelect;
  return /*#__PURE__*/_jsx(ImageTodoCardWrapper, {
    type: "button",
    onClick: function onClick() {
      onSelect(templateId, skipPdp);
      trackEvent({
        todoStart: {
          title: title,
          entryPoint: TodoEntryPoint.TODO_ENTRY_POINT_TODO_DISCOVERY,
          type: skipPdp ? TodoType.TODO_TYPE_B : TodoType.TODO_TYPE_A
        }
      });
    },
    "data-testid": "sample-todo-card",
    children: /*#__PURE__*/_jsxs(ImageTodoCardContainer, {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "base000",
      position: "relative",
      children: [/*#__PURE__*/_jsx(ImageWithFallback, {
        src: tileImageUrl
      }), /*#__PURE__*/_jsx(Box, {
        px: "small4",
        py: "normal1",
        children: /*#__PURE__*/_jsx(InteractiveBlock, {
          weight: "semibold",
          textAlign: "left",
          children: title
        })
      })]
    })
  });
};
export var CustomTodoBanner = function CustomTodoBanner(_ref2) {
  var title = _ref2.title,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'xs' : _ref2$size,
      ctaText = _ref2.ctaText,
      onClick = _ref2.onClick;
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    gap: "normal1",
    my: "small4",
    "data-testid": "create-custom-todo-banner",
    children: [/*#__PURE__*/_jsx(Title, {
      textAlign: "center",
      size: size,
      children: title
    }), /*#__PURE__*/_jsx(Box, {
      display: "flex",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Button, {
        size: "md",
        onClick: onClick,
        "data-testid": "custom-todo-button",
        children: ctaText
      })
    })]
  });
};

var ImageWithFallback = function ImageWithFallback(_ref3) {
  var src = _ref3.src;

  var _useState = useState(false),
      error = _useState[0],
      setError = _useState[1];

  return /*#__PURE__*/_jsx(ImageContainer, {
    position: "relative",
    backgroundColor: error ? 'sky' : undefined,
    minHeight: 143,
    children: /*#__PURE__*/_jsx(Image, {
      src: error ? imageFallback.src : src,
      layout: "fill",
      objectFit: "cover",
      onError: function onError() {
        setError(true);
      }
    })
  });
};

var ImageTodoCardWrapper = styled.button.withConfig({
  componentId: "sc-xjroxq-0"
})(["background:transparent;box-sizing:content-box;border:none;padding:0;max-width:", ";"], pxToRem(242));
var ImageContainer = styled(Box).withConfig({
  componentId: "sc-xjroxq-1"
})(["border-radius:0.44rem 0.44rem 0 0;"]);
var ImageTodoCardContainer = styled(Box).withConfig({
  componentId: "sc-xjroxq-2"
})(["&&{border:1px solid ", ";border-radius:", ";cursor:pointer;font-size:", ";img{border-radius:0.44rem 0.44rem 0 0;}&:hover{border-color:", ";}}"], theme.colors.sandDark, theme.radii.small, getFontSize('bodyMd'), theme.colors.stone);
var InteractiveBlock = styled(Interactive).withConfig({
  componentId: "sc-xjroxq-3"
})(["&&{display:block;}"]);